<template>
  <div class="calendars-ui-kit">
    <h2>Calendars</h2>
    <div class="row">
      <div class="col-12 app-item">
        <vc-calendar :columns="2" class="app-calendar"></vc-calendar>
      </div>
    </div>
    <hr />
    <h2>static Date-pickers</h2>
    <div class="row">
      <div class="col-6 app-item">
        <vc-date-picker v-model="staticDatePicker" class="app-date-picker" />
        Значение: {{ staticDatePicker }}
      </div>
    </div>
    <hr />
    <h2>field Date-pickers</h2>
    <div class="row">
      <div class="col-4 app-item">
        <app-calendar-field
          title="Календарь без даты"
          placeholder="Укажите дату"
          tooltip="Укажите дату"
          v-model="datePickerNoneDate"
        ></app-calendar-field>
        Значение: {{ datePickerNoneDate }}
      </div>
      <div class="col-4 app-item">
        <app-calendar-field
          title="Календарь с текущим днем"
          placeholder="Укажите дату"
          tooltip="Укажите дату"
          v-model="datePickerNowDate"
        ></app-calendar-field>
        Значение: {{ datePickerNowDate }}
      </div>
      <div class="col-4 app-item">
        <app-calendar-field
          title="Календарь с максимальной датой"
          placeholder="Укажите дату"
          tooltip="Укажите дату"
          v-model="datePickerMaxDate"
          :maxDate="new Date()"
        ></app-calendar-field>
        Значение: {{ datePickerMaxDate }}
      </div>
      <div class="col-4 app-item">
        <app-calendar-field
          title="Календарь с минимальной датой"
          placeholder="Укажите дату"
          tooltip="Укажите дату"
          v-model="datePickerMinDate"
          :minDate="new Date()"
        ></app-calendar-field>
        Значение: {{ datePickerMinDate }}
      </div>
      <div class="col-4 app-item">
        <app-calendar-field
          title="Календарь с установленой датой"
          placeholder="Укажите дату"
          tooltip="Укажите дату"
          v-model="datePickerDate"
        ></app-calendar-field>
        Значение: {{ datePickerDate }}
      </div>
      <div class="col-4 app-item">
        <app-calendar-field
          title="mode dateTime"
          placeholder="Укажите дату"
          tooltip="Укажите дату"
          v-model="datePickerDate"
          mode="dateTime"
          isReadonly
        ></app-calendar-field>
        Значение: {{ datePickerDate }}
      </div>
    </div>
    <h2>Range</h2>
    <div class="row">
      <div class="col-4 app-item">
        <vc-date-picker
          is-range
          v-model="rangeDatePicker"
          class="app-date-picker"
          :model-config="rangeConfig"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <div class="app-date-picker__wrapper">
              <input
                :value="inputValue.start"
                v-on="inputEvents.start"
                ref="inputRange1"
                placeholder="01.01.2021"
                class="app-date-picker__input"
                v-autowidth="{ minWidth: '60px', comfortZone: 0 }"
                @input="handlerInput1"
              />
              <span class="app-date-picker__delimiter"> - </span>
              <input
                :value="inputValue.end"
                v-on="inputEvents.end"
                ref="inputRange2"
                placeholder="01.01.2021"
                class="app-date-picker__input"
                v-autowidth="{ minWidth: '60px', comfortZone: 0 }"
                @input="handlerInput2"
              />
            </div>
          </template>
        </vc-date-picker>
        Значение: {{ rangeDatePicker.start }} - {{ rangeDatePicker.end }}
      </div>
    </div>
    <h2>Calendar Dropdown</h2>
    <div class="row">
      <div class="col-4 app-item">
        <app-calendar-dropdown
          :minDate="new Date()"
          placeholder="Укажите дату и время"
          title="Дата и время"
          v-model="calendarDropdown.value"
        ></app-calendar-dropdown>
      </div>
      <div class="col-4 app-item">
        <app-calendar-dropdown
          :minDate="new Date()"
          placeholder="Укажите дату и время"
          title="Дата и время(пустое)"
          v-model="calendarDropdown2.value"
        ></app-calendar-dropdown>
      </div>
      <div class="col-4 app-item">
        <app-calendar-dropdown
          :minDate="new Date()"
          placeholder="Укажите дату и время"
          title="Дата и время(не ровное время)"
          v-model="calendarDropdown3.value"
        ></app-calendar-dropdown>
      </div>
      <div class="col-4 app-item">
        <app-calendar-dropdown
          isPerpetualBtn
          :type="calendarDropdown4.type"
          :minDate="new Date()"
          placeholder="Укажите дату и время"
          title="Дата и время(бесконечность)"
          v-model="calendarDropdown4.value"
          @type="calendarDropdown4.type = $event"
        ></app-calendar-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import Cleave from 'cleave.js';

export default {
  name: 'CalendarsUIkit',
  components: {
    AppCalendarField: () => import('@/components/ui/AppCalendarField'),
    AppCalendarDropdown: () => import('@/components/ui/AppCalendarDropdown'),
  },
  data: () => ({
    datePickerNoneDate: '',
    datePickerDateTime: new Date(),
    datePickerNowDate: new Date(),
    datePickerMaxDate: new Date(),
    datePickerMinDate: new Date(),
    staticDatePicker: new Date(),
    datePickerDate: '2021-03-01',
    rangeDatePicker: {
      start: '',
      end: '',
    },
    rangeInput: '',
    rangeConfig: {
      start: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      end: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
    },
    calendarDropdown: {
      type: 'date',
      value: '2021-10-02 08:00:00',
    },
    calendarDropdown2: {
      type: 'empty',
      value: null,
    },
    calendarDropdown3: {
      type: 'date',
      value: '2021-10-02 08:25:00',
    },
    calendarDropdown4: {
      type: 'perpetual',
      value: null,
    },
  }),
  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const cleaveRange1 = new Cleave(this.$refs.inputRange1, {
      delimiters: ['.', '.', ' '],
      blocks: [2, 2, 4],
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const cleaveRange2 = new Cleave(this.$refs.inputRange2, {
      delimiters: ['.', '.', ' '],
      blocks: [2, 2, 4],
    });
  },
  methods: {
    onDateRangeChange(value) {
      this.rangeInput =
        value.start && value.end
          ? `${this.$options.filters.dateFormat(
              value.start
            )} - ${this.$options.filters.dateFormat(value.end)}`
          : '';
    },
    handlerInput1(event) {
      if (event.target.value.length === 10) {
        this.$refs.inputRange1.blur();
        this.$refs.inputRange2.focus();
      }
    },
    handlerInput2(event) {
      if (event.target.value.length === 0) {
        this.$refs.inputRange1.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-date-picker {
  &__wrapper {
    display: inline-flex;
    background-color: $white;
    border: 1px solid #000;
  }

  &__input {
    @include input-reset;

    height: 24px;
  }

  &__delimiter {
    // -
  }
}
</style>
